import axiosInstance from "@lib/axios";
import { Product } from "@types";
import { AxiosResponse } from "axios";

export const getAllProducts = async () => {
    const { data }: AxiosResponse<{ products: Product[] }> = await axiosInstance.get("/user/products");

    return data;
};
